import { NotificationActionInfo } from './_types';
import { NotificationActionType } from '~/enums/_types';
import { NotificationInfo } from '~/api/notifications/_types';
import { executeRoute } from '~/utils/routeUtils';

const isDataWithId = (data: unknown): data is { Id: number | string } => {
    return data !== null && typeof data === 'object' && 'Id' in data;
};

export const getActions = (): NotificationActionInfo[] => {
    return [
        {
            group: NotificationActionType.OrderConfirmed,
            actionKey: NotificationActionType.OrderConfirmed,
            label: `notifications.actions.${NotificationActionType.OrderConfirmed}.action`,
            canExecuteFn: (info: NotificationInfo) => info.AdditionalInfo != null,
            executeFn: async (info: NotificationInfo) => {
                if (!isDataWithId(info.AdditionalInfo)) return false;

                return await executeRoute({
                    name: 'orders-id',
                    params: { id: info.AdditionalInfo.Id },
                });
            },
        },
        {
            group: NotificationActionType.OrderInvoice,
            actionKey: NotificationActionType.OrderInvoice,
            label: `notifications.actions.${NotificationActionType.OrderInvoice}.action`,
            canExecuteFn: (info: NotificationInfo) => info.AdditionalInfo != null,
            executeFn: async (info: NotificationInfo) => {
                if (!isDataWithId(info.AdditionalInfo)) return false;

                return await executeRoute({
                    name: 'orders-id',
                    params: { id: info.AdditionalInfo.Id },
                });
            },
        },
        {
            group: NotificationActionType.OrderReady,
            actionKey: NotificationActionType.OrderReady,
            label: `notifications.actions.${NotificationActionType.OrderReady}.action`,
            canExecuteFn: (info: NotificationInfo) => info.AdditionalInfo != null,
            executeFn: async (info: NotificationInfo) => {
                if (!isDataWithId(info.AdditionalInfo)) return false;

                return await executeRoute({
                    name: 'orders-id',
                    params: { id: info.AdditionalInfo.Id },
                });
            },
        },
        {
            group: NotificationActionType.ServiceCallCompleted,
            actionKey: NotificationActionType.ServiceCallCompleted,
            label: `notifications.actions.${NotificationActionType.ServiceCallCompleted}.action`,
            canExecuteFn: (info: NotificationInfo) => info.AdditionalInfo != null,
            executeFn: async (info: NotificationInfo) => {
                if (!isDataWithId(info.AdditionalInfo)) return false;

                return await executeRoute({
                    name: 'service-calls-id',
                    params: { id: info.AdditionalInfo.Id },
                });
            },
        },
        {
            group: NotificationActionType.ServiceCallEvidenced,
            actionKey: NotificationActionType.ServiceCallEvidenced,
            label: `notifications.actions.${NotificationActionType.ServiceCallEvidenced}.action`,
            canExecuteFn: (info: NotificationInfo) => info.AdditionalInfo != null,
            executeFn: async (info: NotificationInfo) => {
                if (!isDataWithId(info.AdditionalInfo)) return false;

                return await executeRoute({
                    name: 'service-calls-id',
                    params: { id: info.AdditionalInfo.Id },
                });
            },
        },
    ];
};
